"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _table = require("../../table");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

var _default = function _default(_ref) {
  var isHeader = _ref.isHeader,
      unused = _objectWithoutProperties(_ref, ["isHeader"]);

  return isHeader ? React.createElement(_table.TableHeaderCell, null, React.createElement(_table.TableHeaderText, unused)) : React.createElement(_table.TableCell, null, React.createElement(_table.TableText, unused));
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-web/components/typography/Markdown/TableCell.js
// module id = ./node_modules/quark-web/components/typography/Markdown/TableCell.js
// module chunks = 0